import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import img1 from "./customCardImg/education1.png";

const NewCustomCard = ({
  card_id,
  title,
  description,
  img,
  onButtonClick,
  bgColor,
}) => {
  return (
    <Box
      sx={{
        width: "284px",
        height: "174px",
        // border: "1px solid blue",
        borderRadius: "12px",
        // backgroundColor: "#fff",
        // backgroundColor: bgColor,
        backgroundImage: `url('${img1}')`, // ✅ Add your image path here
        backgroundSize: "contained", // 🔄 Covers full area
        backgroundRepeat: "no-repeat", // 🚫 Prevents repeat
        backgroundPosition: "center", // 🎯 Centers image
        // backgroundColor: "#f2ffee",
        backgroundColor: bgColor,
        position: "relative",
        zIndex: 10,
        overflow: "hidden",
        // marginTop: "40px",
        padding: "8px",
      }}
    >
      <Stack
        sx={{
          // border: "1px solid red",
          width: "100%",
          height: "100%",
        }}
      >
        <Stack
          sx={{
            // border: "1px solid green",
            // color: "rgb(5 78 146)",
            fontFamily: "'Roboto', sans-serif",
            height: "100%",
            width: "60%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Stack sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Stack
              sx={{
                // border: "1px solid green",
                width: "100%",
                fontSize: "19px",
                fontWeight: 600,
              }}
            >
              {/* Education & Edtech{" "} */}
              {title}
            </Stack>{" "}
            <Stack
              sx={{
                //  border: "1px solid green",
                width: "100%",
                fontSize: "12px",
                fontWeight: 400,
              }}
            >
              {/* Learn anytime, anywhere with smart tools.{" "} */}
              {description}
            </Stack>{" "}
          </Stack>
          <Stack
            sx={{
              // border: "1px solid green",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              marginBottom: "4px",
            }}
          >
            <Button variant="contained" size="small">
              Know more
            </Button>{" "}
          </Stack>{" "}
        </Stack>
      </Stack>
    </Box>
  );
};

export default NewCustomCard;
